import { Field } from 'formik';
import { Grid } from '@mui/material';
import MuiValidSelect from 'src/components/input/MuiValidSelect';
import MuiValidTextField from './input/MuiValidTextField';
import { States } from '../util/states';

const BankruptcyInformation = () => {
  return (
    <>
      <Grid
        id="bankruptcy-information"
        container
        sx={{ mt: '0.25rem' }}
        rowSpacing={4}
        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
      >
        <Grid item xs={12} md={6}>
          <Field
            component={MuiValidSelect}
            itemValues={['CHAP7', 'CHAP11', 'CHAP13']}
            itemLabels={['Chapter 7', 'Chapter 11', 'Chapter 13']}
            label="Type of Bankruptcy"
            name="bankruptcyType"
            variant="standard"
          ></Field>
        </Grid>
        <Grid item xs={12} md={6}>
          <Field
            component={MuiValidSelect}
            label="State of Bankruptcy"
            name="bankruptcyState"
            itemValues={States}
            itemLabels={States}
            variant="standard"
          ></Field>
        </Grid>
        <Grid item xs={12} md={6}>
          <Field
            component={MuiValidSelect}
            itemValues={['Y', 'N']}
            itemLabels={['Yes', 'No']}
            label="Business in Operation?"
            name="busInOper"
            variant="standard"
          ></Field>
        </Grid>
        <Grid item xs={12} md={6}>
          <Field
            component={MuiValidTextField}
            label="What is the Case Number?"
            name="bankruptcyCaseno"
            variant="standard"
            sx={{ width: '100%' }}
            inputProps={{ maxLength: 20 }}
            InputLabelProps={{ shrink: true }}
          ></Field>
        </Grid>
        <Grid item xs={12} md={6}>
          <Field
            component={MuiValidTextField}
            label="Date of Bankruptcy?"
            name="bankruptcyDate"
            type="Date"
            variant="standard"
            sx={{ width: '100%' }}
            InputLabelProps={{ shrink: true }}
          ></Field>
        </Grid>
      </Grid>
    </>
  );
};

export default BankruptcyInformation;
